import React, { useState } from 'react';
import './Chatlist.css';

const ChatList = ({ users, onUserClick, unreadCounts = {} }) => {
  const [search, setSearch] = useState('');

  const filtered = users.filter(u =>
    u.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="chat-list">
      <h3>Users</h3>

      <input
        className="search-barr"
        type="text"
        placeholder="Search users..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />

      {filtered.length ? (
        <ul>
          {filtered.map(u => {
            const uid = String(u.userId);
            const unread = unreadCounts[uid] || 0;

            return (
              <li key={uid} className="chat-list-item" onClick={() => onUserClick(u)}>
                {u.profilePicture ? (
                  <img
                    src={`data:image/jpeg;base64,${u.profilePicture}`}
                    alt={u.name}
                    className="profileImage"
                  />
                ) : (
                  <div className="default-profile-image" />
                )}

                <span className="chat-user-name">{u.name}</span>

                {unread > 0 && <span className="unread-badge">{unread}</span>}
              </li>
            );
          })}
        </ul>
      ) : (
        <p>No users found.</p>
      )}
    </div>
  );
};

export default ChatList;
